export default __webpack_public_path__ + "static/media/IMG_2122.0036c822.jpg";